import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportIssueConfiguration, ReportIssueType } from './reports-issue-card/reports-issue.configuration';

@Component({
  selector: 'app-reports-edit',
  templateUrl: './reports-edit.component.html',
  styleUrls: ['./reports-edit.component.scss']
})
export class ReportsEditComponent implements OnInit {

  SellerConfiguration : ReportIssueConfiguration = ReportIssueConfiguration.create().setTitle("Vendita diretta").setButtonLabel("Scarica").setType(ReportIssueType.SALE)
  BuyerConfiguration : ReportIssueConfiguration = ReportIssueConfiguration.create().setTitle("Acquisto rivendita").setButtonLabel("Scarica").setType(ReportIssueType.RESALE)


  constructor(private route : ActivatedRoute, private cdr : ChangeDetectorRef) { }

  ngOnInit() {

    this.route
    .data
    .subscribe(data => {

      data['title'] = 'CT_MENU.reports';
      data['urls'] = [{ title: data['title'] }];

      this.cdr.detectChanges();

    })
  }

}
